import React, { useEffect, useState } from "react";
import { useCartorio } from "../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../Hooks/funcionarioCartorio";
import { IImovel, useImovel } from "../../Hooks/imoveis";
import api from "../../Services/api";
import { Alert } from "../Error/Alert";
import { ImovelInput } from "../ImovelInput";
import { ModalLoader } from "../ModalLoader";
import { MunicipioSelector } from "../MunicipioSelector";
import { TipoOperacaoSelector } from "../TipoOperacaoSelector";
import { IPrefeitura, usePrefeitura } from "../../Hooks/usePrefeitura";
import {
  // Button,
  // Container,
  HandleButtons,
  HandleFormulario,
  HeaderSelectorButton,
  HeaderSelectorFormsButtons,
  SectionTitle,
  Title,
} from "./styles";

import {
  Container,
  Typography,
  Grid,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import DatePicker from "react-date-picker";
import { IImovelFocus } from "../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import { IOperacao, useOperacao } from "../../Hooks/operacoes";
import { createGlobalStyle } from "styled-components";
import theme from "../../Styles/theme";
import { helpNumber } from "../../Services/helpNumber";
import { useNavigate } from "react-router-dom";
import { app_base_url } from "../../Utils/baseUrl";
import { IImovelRuralFocus } from "../../Pages/Cartorio_Pages/App_Pages/ImovelFocusRural";
import { isRural } from "../../Utils/isRural";
import { useFuncionarioPrefeitura } from "../../Hooks/funcionarioPrefeitura";
import {
  TipoFormularioRural,
  alteraImovelRuralForm,
  getTipoFormularioRural,
} from "../../Services/alteraImovelForm";
import {
  Municipio_Formulario,
  tipoFormularioRualList,
} from "../../Utils/tipoFormularioRualList";
interface Props {
  handleClose(): void;
  imovel?: IImovelFocus | IImovelRuralFocus;
  handleSetImovel?(im: IImovelFocus): void;
  rural?: boolean;
}
export function AddImovelForm({
  handleClose,
  imovel = {} as IImovelFocus,
  handleSetImovel = (im: IImovelFocus) => { },
  rural,
}: Props) {
  const DatePickerWrapperStyles = createGlobalStyle`
  .formata-date-picker {
      background-color: ${theme.colors.secondary};
      border:none;
      border-radius:0.25rem;
      color:${theme.colors.dark};
     font-size: calc(0.4vw + 8px);
    width:100%;
  }
`;
  const limparNumeroComVirgula = (valor: string): string => {
    if (!valor) return '';

    // Remove tudo que não for dígito ou vírgula
    valor = valor.replace(/[^\d,]/g, '');

    // Divide em parte inteira e decimal
    const partes = valor.split(',');

    let inteiro = partes[0];
    const decimal = partes[1];

    // Remove zeros à esquerda
    inteiro = inteiro.replace(/^0+(?!$)/, '');

    // Adiciona o ponto de milhar na parte inteira
    inteiro = inteiro.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Se houver parte decimal, concatena com vírgula
    if (decimal !== undefined) {
      return `${inteiro},${decimal}`;
    }

    return inteiro;
  };

  const formatarMilhares = (valor: string): string => {
    const numeros = valor.replace(/\D/g, ""); // remove tudo que não for número
    return numeros.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };


  const { handleSetNewImovel, newImovel } = useImovel();
  const {
    prefeituraIsLogged,
    prefeitura,
    getPrefeituras,
    prefeituras,
  } = usePrefeitura();
  const { getOperacoes, operacoes } = useOperacao();
  const {
    funcionarioPrefeituraIsLogged,
    funcionariosPrefeitura,
  } = useFuncionarioPrefeitura();

  const navigate = useNavigate();

  const [tipo_terras, setTipos_terras] = useState(tipoFormularioRualList[0]);

  const [TIPO_TERRA_CAMPOS, setTIPO_TERRA_CAMPOS] = useState([
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
  ]);

  const [tipoFormularioRural, setTipoFormularioRural] = useState(
    {} as TipoFormularioRural
  );
  const [PREFEITURA, setPREFEITURA] = useState({} as IPrefeitura);
  const [OPERACAO, setOPERACAO] = useState({} as IOperacao);
  const [LOCALIZACAO, setLOCALIZACAO] = useState("");
  const [BAIRRO, setBAIRRO] = useState("");
  const [SITUACAO_QUADRA, setSITUACAO_QUADRA] = useState("");
  const [LOTE, setLOTE] = useState("");
  const [ZONA, setZONA] = useState("");
  const [QUADRA, setQUADRA] = useState("");
  const [SUBLOTE, setSUBLOTE] = useState("");

  const [AREA_TRANSMITIDA, setAREA_TRANSMITIDA] = useState("0,00");

  const [FRENTE, setFRENTE] = useState("0,00");
  const [FUNDO, setFUNDO] = useState("0,00");
  const [LADO_ESQUERDO, setLADO_ESQUERDO] = useState("0,00");
  const [LADO_DIREITO, setLADO_DIREITO] = useState("0,00");

  const [APTIDAO_BOA, setAPTIDAO_BOA] = useState("0,00");
  const [APTIDAO_REGULAR, setAPTIDAO_REGULAR] = useState("0,00");
  const [APTIDAO_RESTRITA, setAPTIDAO_RESTRITA] = useState("0,00");
  const [PASTAGEM_PLANA, setPASTAGEM_PLANA] = useState("0,00");
  const [SIVICULTURA, setSIVICULTURA] = useState("0,00");
  const [RESERVA_NATURAL, setRESERVA_NATURAL] = useState("0,00");
  const [TIPO_TERRA_7, setTIPO_TERRA_7] = useState("0,00");
  const [TIPO_TERRA_8, setTIPO_TERRA_8] = useState("0,00");

  const [MATRICULA, setMATRICULA] = useState<string>("0");

  const [AREA, setAREA] = useState("0,00");

  const [VALOR_CARTORIO_TERRENO, setVALOR_CARTORIO_TERRENO] = useState("0,00");

  const [TRANSCRICAO, setTRANSCRICAO] = useState("");

  const [error, setError] = useState({ title: "", message: "" });
  const [loading, setloading] = useState(false);

  const { cartorio, cartorioIsLogged, checarToken } = useCartorio();
  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();
  function validateForm() {
    if (LOCALIZACAO.trim().length == 0) {
      setError({
        title: "Localizão não foi preenchida!",
        message:
          "É necessário preencher o campor LOCALIZACAO para criar um imóvel.",
      });
      return false;
    }
    if (rural) {
      const grupos = tipo_terras.reduce((acc, tipo, index) => {
        const grupo = tipo.grupo || "Sem Grupo";
        if (!acc[grupo]) acc[grupo] = [];
        acc[grupo].push(helpNumber(TIPO_TERRA_CAMPOS[index] || "0"));
        return acc;
      }, {} as Record<string, number[]>);

      for (const grupo in grupos) {
        const soma = grupos[grupo].reduce((total, val) => total + val, 0);

        if (soma > 100) {
          setError({
            title: `Grupo "${grupo}" acima de 100%!`,
            message: `A soma dos campos do grupo "${grupo}" ultrapassa 100%, resultando em ${soma.toFixed(2)}%.`,
          });
          return false;
        }

        if (soma < 100) {
          setError({
            title: `Grupo "${grupo}" abaixo de 100%!`,
            message: `A soma dos campos do grupo "${grupo}" está incompleta, totalizando apenas ${soma.toFixed(2)}%.`,
          });
          return false;
        }
      }
    }
    else {
      if (BAIRRO.trim().length == 0) {
        setError({
          title: "Bairro não foi preenchido!",
          message:
            "É necessário preencher o campo BAIRRO para criar um imóvel.",
        });
        return false;
      }

      if (helpNumber(FRENTE) < 0 || helpNumber(FRENTE) == undefined) {
        setError({
          title: "A área frontal não foi preenchido!",
          message:
            "É necessário preencher o campo área frontal para criar um imóvel.",
        });
        return false;
      }
      if (helpNumber(FUNDO) < 0 || helpNumber(FUNDO) == undefined) {
        setError({
          title: "A área dos fundos não foi preenchido!",
          message:
            "É necessário preencher o campo área dos fundos para criar um imóvel.",
        });
        return false;
      }

      if (
        helpNumber(LADO_DIREITO) < 0 ||
        helpNumber(LADO_DIREITO) == undefined
      ) {
        setError({
          title: "A área do lado direito não foi preenchido!",
          message:
            "É necessário preencher o campo área do lado direito para criar um imóvel.",
        });
        return false;
      }

      if (
        helpNumber(LADO_ESQUERDO) < 0 ||
        helpNumber(LADO_ESQUERDO) == undefined
      ) {
        setError({
          title: "A área do lado esquerdo não foi preenchido!",
          message:
            "É necessário preencher o campo área do lado esquerdo para criar um imóvel.",
        });
        return false;
      }

      if (LOTE.trim().length == 0) {
        setError({
          title: "A LOTE total não foi preenchido!",
          message: "É necessário preencher o campo LOTE para criar um imóvel.",
        });
        return false;
      }
      if (QUADRA.trim().length == 0) {
        setError({
          title: "A QUADRA não foi preenchida!",
          message:
            "É necessário preencher o campo QUADRA para criar um imóvel.",
        });
        return false;
      }
    }

    if (Number(AREA) <= 0) {
      setError({
        title: "A área total não foi preenchido!",
        message:
          "É necessário preencher o campo área total para criar um imóvel.",
      });
      return false;
    }

    if (!OPERACAO.ID) {
      setError({
        title: "Nenhum tipo de operação selecionada!",
        message: "É necessário selecioanar um tipo de operação!.",
      });
      return false;
    }

    if (
      !PREFEITURA.ID &&
      !(prefeituraIsLogged || funcionarioPrefeituraIsLogged)
    ) {
      setError({
        title: "Nenhum município foi selecionado!",
        message: "É necessário selecioanar um munícipio!.",
      });
      return false;
    }

    return true;
  }

  async function post() {
    if (validateForm()) {
      try {
        setloading(true);
        if (cartorioIsLogged) {
          await checarToken();
        }

        if (funcionarioCartorioIsLogged) {
          await checarTokenFuncionario();
        }

        if (imovel.ID) {
          if (rural) {
            if ((await getTipoFormularioRural(imovel.ID)) != null) {
              await alteraImovelRuralForm(tipoFormularioRural, "U");
            } else {
              await alteraImovelRuralForm(tipoFormularioRural, "C");
            }

            const { data } = await api.put<IImovelFocus>(`/imovel-rural`, {
              ID: imovel.ID,
              LOCALIZACAO,
              NUMERO: imovel.NUMERO,

              OPERACAO_ID: OPERACAO.ID,
              VALOR_CARTORIO_TERRENO: imovel.VALOR_CARTORIO_TERRENO,
              PREFEITURA_ID: PREFEITURA.ID ? PREFEITURA.ID : prefeitura.ID,
              CARTORIO_ID:
                prefeituraIsLogged || funcionarioPrefeituraIsLogged
                  ? null
                  : cartorio.ID,

              VALOR_CARTORIO_BENFEITORIAS: imovel.VALOR_CARTORIO_BENFEITORIAS,

              VALOR_PREFEITURA_BENFEITORIAS:
                imovel.VALOR_PREFEITURA_BENFEITORIAS,
              VALOR_PREFEITURA_TERRENO: imovel.VALOR_PREFEITURA_TERRENO,
              DATA_CRIACAO: imovel.DATA_CRIACAO,
              ENVIADO: imovel.ENVIADO,
              AVALIADO: imovel.AVALIADO,
              ALIQUOTA: imovel.ALIQUOTA,
              ALIQUOTA2: imovel.ALIQUOTA2,
              ENTRADA: imovel.ENTRADA,
              AREA_TRANSMITIDA: helpNumber(AREA_TRANSMITIDA),
              AREA: helpNumber(AREA),

              APTIDAO_BOA: helpNumber(APTIDAO_BOA),
              APTIDAO_REGULAR: helpNumber(APTIDAO_REGULAR),
              APTIDAO_RESTRITA: helpNumber(APTIDAO_RESTRITA),
              PASTAGEM_PLANA: helpNumber(PASTAGEM_PLANA),
              SIVICULTURA: helpNumber(SIVICULTURA),
              RESERVA_NATURAL: helpNumber(RESERVA_NATURAL),
              TIPO_TERRA_7: helpNumber(TIPO_TERRA_7),
              TIPO_TERRA_8: helpNumber(TIPO_TERRA_8),
              MATRICULA: MATRICULA ? Number(MATRICULA.replace(/\./g, "")) : null,
              TRANSCRICAO: TRANSCRICAO,
            });

            data.MUNICIPIO = PREFEITURA.NOME;
            data.OPERACAO = OPERACAO.DESCRICAO;
            data.OPERACAO = OPERACAO.DESCRICAO;
            data.CLASSE_NAO_TRIBUTADO = imovel.CLASSE_NAO_TRIBUTADO;
            data.TIPO_TRIBUTACAO = imovel.TIPO_TRIBUTACAO;
            data.OBSERVACOES = imovel.OBSERVACOES;
            data.OBS_NAO_TRIBUTADO = imovel.OBS_NAO_TRIBUTADO;
            data.CARTORIO_TITULO = imovel.CARTORIO_TITULO;
            handleSetImovel(data);
          } else {

            const { data } = await api.put<IImovelFocus>(`/imovel`, {
              ID: imovel.ID,
              LOCALIZACAO,
              NUMERO: imovel.NUMERO,
              BAIRRO,

              LOTE,
              QUADRA,
              ZONA,
              SUBLOTE,
              SITUACAO_QUADRA,
              OPERACAO_ID: OPERACAO.ID,
              VALOR_CARTORIO_TERRENO: imovel.VALOR_CARTORIO_TERRENO,
              PREFEITURA_ID: PREFEITURA.ID ? PREFEITURA.ID : prefeitura.ID,
              CARTORIO_ID: cartorio.ID,

              FRENTE: Number.parseFloat(`${helpNumber(FRENTE)}`).toFixed(6),
              LADO_DIREITO: Number.parseFloat(
                `${helpNumber(LADO_DIREITO)}`
              ).toFixed(6),
              LADO_ESQUERDO: Number.parseFloat(
                `${helpNumber(LADO_ESQUERDO)}`
              ).toFixed(6),
              FUNDO: Number.parseFloat(`${helpNumber(FUNDO)}`).toFixed(6),

              VALOR_CARTORIO_BENFEITORIAS: imovel.VALOR_CARTORIO_BENFEITORIAS,
              AREA: Number.parseFloat(`${helpNumber(AREA)}`).toFixed(6),

              VALOR_PREFEITURA_BENFEITORIAS:
                imovel.VALOR_PREFEITURA_BENFEITORIAS,
              VALOR_PREFEITURA_TERRENO: imovel.VALOR_PREFEITURA_TERRENO,
              DATA_CRIACAO: imovel.DATA_CRIACAO,
              ENVIADO: imovel.ENVIADO,
              AVALIADO: imovel.AVALIADO,
              ALIQUOTA: imovel.ALIQUOTA,
              ALIQUOTA2: imovel.ALIQUOTA2,
              ENTRADA: imovel.ENTRADA,
              AREA_TRANSMITIDA: Number.parseFloat(
                `${helpNumber(AREA_TRANSMITIDA)}`
              ).toFixed(6),
              MATRICULA: MATRICULA ? Number(MATRICULA.replace(/\./g, "")) : null,
              TRANSCRICAO: TRANSCRICAO,
            });
            data.MUNICIPIO = PREFEITURA.NOME;
            data.OPERACAO = OPERACAO.DESCRICAO;
            data.OPERACAO = OPERACAO.DESCRICAO;
            data.CLASSE_NAO_TRIBUTADO = imovel.CLASSE_NAO_TRIBUTADO;
            data.TIPO_TRIBUTACAO = imovel.TIPO_TRIBUTACAO;
            data.OBSERVACOES = imovel.OBSERVACOES;
            data.OBS_NAO_TRIBUTADO = imovel.OBS_NAO_TRIBUTADO;

            handleSetImovel(data);
          }
        } else {
          let helperId;
          if (rural) {
            const { data } = await api.post<IImovel>(`/imovel-rural`, {
              LOCALIZACAO,
              AREA: helpNumber(AREA),
              AREA_TRANSMITIDA: Number.parseFloat(
                `${helpNumber(AREA_TRANSMITIDA)}`
              ).toFixed(6),
              OPERACAO_ID: OPERACAO.ID,
              VALOR_CARTORIO_TERRENO: helpNumber(VALOR_CARTORIO_TERRENO),
              PREFEITURA_ID: PREFEITURA.ID ? PREFEITURA.ID : prefeitura.ID,
              CARTORIO_ID: cartorio.ID,
              APTIDAO_BOA: helpNumber(APTIDAO_BOA),
              APTIDAO_REGULAR: helpNumber(APTIDAO_REGULAR),
              APTIDAO_RESTRITA: helpNumber(APTIDAO_RESTRITA),
              PASTAGEM_PLANA: helpNumber(PASTAGEM_PLANA),
              SIVICULTURA: helpNumber(SIVICULTURA),
              RESERVA_NATURAL: helpNumber(RESERVA_NATURAL),
              MATRICULA: MATRICULA ? Number(MATRICULA.replace(/\./g, "")) : null,
              TIPO_TERRA_7: helpNumber(TIPO_TERRA_7),
              TIPO_TERRA_8: helpNumber(TIPO_TERRA_8),
              TRANSCRICAO: TRANSCRICAO,
            });
            setTipoFormularioRural({
              TIPO: tipoFormularioRural.TIPO,
              IMOVEL_ID: data.ID,
            });
            await alteraImovelRuralForm(
              {
                TIPO: tipoFormularioRural.TIPO,
                IMOVEL_ID: data.ID,
              },
              "C"
            );
            handleSetNewImovel({
              ID: data.ID,
              LOCALIZACAO: data.LOCALIZACAO,
              BAIRRO: data.BAIRRO,
              AREA: data.AREA,
              LOTE: data.LOTE,
              QUADRA: data.QUADRA,
              ZONA: data.ZONA,
              SUBLOTE: data.SUBLOTE,
              OPERACAO_ID: data.OPERACAO_ID,
              VALOR_CARTORIO_TERRENO: data.VALOR_CARTORIO_TERRENO,
              VALOR_CARTORIO_BENFEITORIAS: data.VALOR_CARTORIO_BENFEITORIAS,
              VALOR_PREFEITURA_TERRENO: data.VALOR_PREFEITURA_TERRENO,
              VALOR_PREFEITURA_BENFEITORIAS: data.VALOR_PREFEITURA_BENFEITORIAS,
              DATA_CRIACAO: data.DATA_CRIACAO,
              ENVIADO: data.ENVIADO,
              AVALIADO: data.AVALIADO,
              PREFEITURA_ID: data.PREFEITURA_ID,
              CARTORIO_ID: data.CARTORIO_ID,
              FRENTE: data.FRENTE,
              FUNDO: data.FUNDO,
              LADO_DIREITO: data.LADO_DIREITO,
              LADO_ESQUERDO: data.LADO_ESQUERDO,
              SITUACAO_QUADRA: data.SITUACAO_QUADRA,
              NUMERO: data.NUMERO,
              MUNICIPIO: PREFEITURA.NOME,
              TRANSMITENTE: "",
              ADQUIRINTE: "",
              VENC: null,
              APTIDAO_BOA: 0,
              APTIDAO_REGULAR: 0,
              APTIDAO_RESTRITA: 0,
              PASTAGEM_PLANA: 0,
              SIVICULTURA: 0,
              RESERVA_NATURAL: 0,
              ALIQUOTA2: imovel.ALIQUOTA2,
              ENTRADA: imovel.ENTRADA,
              MATRICULA: data.MATRICULA,
              CARTORIO_TITULO: imovel.CARTORIO_TITULO,
              TRANSCRICAO: data.TRANSCRICAO,
            });

            if (funcionarioPrefeituraIsLogged || prefeituraIsLogged) {
              const enviar = await api.patch(`/imovel-rural/enviar/${data.ID}`);
            }
          } else {
            const { data } = await api.post<IImovel>(`/imovel`, {
              LOCALIZACAO,
              BAIRRO,

              LOTE,
              QUADRA,
              ZONA,
              SUBLOTE,
              OPERACAO_ID: OPERACAO.ID,
              VALOR_CARTORIO_TERRENO: helpNumber(VALOR_CARTORIO_TERRENO),
              PREFEITURA_ID: PREFEITURA.ID ? PREFEITURA.ID : prefeitura.ID,
              CARTORIO_ID: cartorio.ID,
              AREA: Number.parseFloat(`${helpNumber(AREA)}`).toFixed(6),
              FRENTE: Number.parseFloat(`${helpNumber(FRENTE)}`).toFixed(6),
              LADO_DIREITO: Number.parseFloat(
                `${helpNumber(LADO_DIREITO)}`
              ).toFixed(6),
              LADO_ESQUERDO: Number.parseFloat(
                `${helpNumber(LADO_ESQUERDO)}`
              ).toFixed(6),
              FUNDO: Number.parseFloat(`${helpNumber(FUNDO)}`).toFixed(6),
              AREA_TRANSMITIDA: Number.parseFloat(
                `${helpNumber(AREA_TRANSMITIDA)}`
              ).toFixed(6),
              SITUACAO_QUADRA,
              MATRICULA: MATRICULA ? Number(MATRICULA.replace(/\./g, "")) : null,
              TRANSCRICAO
            });
            handleSetNewImovel({
              ID: data.ID,
              LOCALIZACAO: data.LOCALIZACAO,
              BAIRRO: data.BAIRRO,
              AREA: data.AREA,
              LOTE: data.LOTE,
              QUADRA: data.QUADRA,

              ZONA: data.ZONA,
              SUBLOTE: data.SUBLOTE,
              OPERACAO_ID: data.OPERACAO_ID,
              VALOR_CARTORIO_TERRENO: data.VALOR_CARTORIO_TERRENO,
              VALOR_CARTORIO_BENFEITORIAS: data.VALOR_CARTORIO_BENFEITORIAS,
              VALOR_PREFEITURA_TERRENO: data.VALOR_PREFEITURA_TERRENO,
              VALOR_PREFEITURA_BENFEITORIAS: data.VALOR_PREFEITURA_BENFEITORIAS,
              DATA_CRIACAO: data.DATA_CRIACAO,
              ENVIADO: data.ENVIADO,
              AVALIADO: data.AVALIADO,
              PREFEITURA_ID: data.PREFEITURA_ID,
              CARTORIO_ID: data.CARTORIO_ID,
              FRENTE: data.FRENTE,
              FUNDO: data.FUNDO,
              LADO_DIREITO: data.LADO_DIREITO,
              LADO_ESQUERDO: data.LADO_ESQUERDO,
              SITUACAO_QUADRA: data.SITUACAO_QUADRA,
              NUMERO: data.NUMERO,
              MUNICIPIO: PREFEITURA.NOME,
              TRANSMITENTE: "",
              ADQUIRINTE: "",
              VENC: null,
              APTIDAO_BOA: 0,
              APTIDAO_REGULAR: 0,
              APTIDAO_RESTRITA: 0,
              PASTAGEM_PLANA: 0,
              SIVICULTURA: 0,
              RESERVA_NATURAL: 0,
              ALIQUOTA2: imovel.ALIQUOTA2,
              ENTRADA: imovel.ENTRADA,
              MATRICULA: data.MATRICULA,
              CARTORIO_TITULO: imovel.CARTORIO_TITULO,
              TRANSCRICAO: data.TRANSCRICAO,
            });

            if (funcionarioPrefeituraIsLogged || prefeituraIsLogged) {
              const enviar = await api.patch(`/imovel/enviar/${data.ID}`);
            }
          }
        }
        handleClose();
      } catch (e) {
        console.log(e);
        setError({
          title: "Não foi possível salvar o imóvel!",
          message:
            "Ocorreu algum erro ao salvar o imóvel, tente novamente mais tarde!",
        });
      } finally {
        setloading(false);
      }
    }
  }

  useEffect(() => {
    if (imovel.ID) {
      setOPERACAO({
        ID: imovel.OPERACAO_ID,
        DESCRICAO: imovel.OPERACAO,
        CARTORIO_ID: imovel.CARTORIO_ID,
      });

      setLOCALIZACAO(imovel.LOCALIZACAO);
      setBAIRRO(imovel.BAIRRO);
      setQUADRA(imovel.QUADRA);
      setSITUACAO_QUADRA(imovel.SITUACAO_QUADRA);
      setZONA(imovel.ZONA);
      setLOTE(imovel.LOTE);
      setSUBLOTE(imovel.SUBLOTE ? imovel.SUBLOTE : "");
      setAREA(
        new Intl.NumberFormat("pt-BR", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 6,
        }).format(imovel.AREA)
      );
      setFRENTE(new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 6 }).format(imovel.FRENTE));
      setFUNDO(new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 6 }).format(imovel.FUNDO));
      setLADO_DIREITO(new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 6 }).format(imovel.LADO_DIREITO));
      setLADO_ESQUERDO(new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 6 }).format(imovel.LADO_ESQUERDO));
      setAREA_TRANSMITIDA(
        imovel.AREA_TRANSMITIDA
          ? new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 6 }).format(imovel.AREA_TRANSMITIDA)
          : "0"
      );
      setPREFEITURA({
        ID: imovel.PREFEITURA_ID,
        NOME: imovel.MUNICIPIO,
        LIGACAO_ID: Number(
          String(imovel.PREFEITURA_ID) + String(imovel.CARTORIO_ID)
        ),
        STATUS: "A",
      });

      if (imovel.MATRICULA) {
        setMATRICULA(new Intl.NumberFormat("pt-BR").format(imovel.MATRICULA));
      }

      setTRANSCRICAO(imovel.TRANSCRICAO || "");

      if (rural) {
        //editar aqui
        setAPTIDAO_BOA(String(imovel.APTIDAO_BOA));
        setAPTIDAO_REGULAR(String(imovel.APTIDAO_REGULAR));
        setAPTIDAO_RESTRITA(String(imovel.APTIDAO_RESTRITA));
        setPASTAGEM_PLANA(String(imovel.PASTAGEM_PLANA));
        setSIVICULTURA(String(imovel.SIVICULTURA));
        setRESERVA_NATURAL(String(imovel.RESERVA_NATURAL));

        setTIPO_TERRA_7(String(imovel.TIPO_TERRA_7));
        setTIPO_TERRA_8(String(imovel.TIPO_TERRA_8));

        setTIPO_TERRA_CAMPOS([
          String(imovel.APTIDAO_BOA),
          String(imovel.APTIDAO_REGULAR),
          String(imovel.APTIDAO_RESTRITA),
          String(imovel.PASTAGEM_PLANA),
          String(imovel.SIVICULTURA),
          String(imovel.RESERVA_NATURAL),
          String(imovel.TIPO_TERRA_7),
          String(imovel.TIPO_TERRA_8),
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
        ]);
      }
    }
  }, [open, imovel]);

  useEffect(() => {
    if (tipoFormularioRural.TIPO) {
      setTipos_terras(tipoFormularioRualList[tipoFormularioRural.TIPO]);
    } else {
      setTipos_terras(tipoFormularioRualList[1]);
    }
  }, [tipoFormularioRural]);

  useEffect(() => {
   
  }, [tipo_terras]);

  useEffect(() => {

    setAPTIDAO_BOA(String(TIPO_TERRA_CAMPOS[0]));
    setAPTIDAO_REGULAR(String(TIPO_TERRA_CAMPOS[1]));
    setAPTIDAO_RESTRITA(String(TIPO_TERRA_CAMPOS[2]));
    setPASTAGEM_PLANA(String(TIPO_TERRA_CAMPOS[3]));
    setSIVICULTURA(String(TIPO_TERRA_CAMPOS[4]));
    setRESERVA_NATURAL(String(TIPO_TERRA_CAMPOS[5]));
    setTIPO_TERRA_7(String(TIPO_TERRA_CAMPOS[6]));
    setTIPO_TERRA_8(String(TIPO_TERRA_CAMPOS[7]));
  }, [TIPO_TERRA_CAMPOS]);

  async function handlerTipoFormulario() {

    if (imovel.ID && isRural()) {
      const tipo = await getTipoFormularioRural(imovel.ID);

      if (tipo) setTipoFormularioRural(tipo);
    }
  }

  useEffect(() => {
    if (prefeitura.ID) {

      const formulario = Municipio_Formulario.find(
        (item) => item.id == prefeitura.ID
      );
      //aqui
      if (formulario && formulario.id) {
        setTipoFormularioRural({
          TIPO: formulario.formulario,
          IMOVEL_ID: imovel.ID ? imovel.ID : 0,
        });
      }
    } else {

      const formulario = Municipio_Formulario.find(
        (item) => item.id == PREFEITURA.ID
      );
      //aqui
      if (formulario && formulario.id) {
        setTipoFormularioRural({
          TIPO: formulario.formulario,
          IMOVEL_ID: imovel.ID ? imovel.ID : 0,
        });
      }
    }


  }, [PREFEITURA, prefeituraIsLogged, funcionarioPrefeituraIsLogged, prefeitura]);

  useEffect(() => {
    handlerTipoFormulario();
  }, [imovel, open]);

  // useEffect(() => {
  //   if (tipoFormularioRural.TIPO == 2) {
  //     setTipos_terras(tipoFormularioRualList[2]);
  //   } else {
  //     setTipos_terras(tipoFormularioRualList[1]);
  //   }
  // }, [tipoFormularioRural]);

  useEffect(() => {
    getPrefeituras(0);
    getOperacoes(cartorio.ID ? cartorio.ID : 1);
  }, [cartorio]);



  return (
    <Container
      style={{
        height: imovel.ID ? "70vh" : "90vh",
        transform: `scale(${95 / 100})`,
        // zoom: `${115 / 100}`,
        transformOrigin: "top center",
      }}
    >
      <Typography variant="h5" gutterBottom>
        {imovel.ID ? "" : `ADICIONAR IMÓVEL ${rural ? "RURAL" : ""}`}
      </Typography>

      <Grid container spacing={3}>
        {!imovel.ID && (cartorioIsLogged || funcionarioCartorioIsLogged) && (
          <Grid item xs={12} sm={6}>
            <FormControl
              fullWidth
              variant="outlined"
              style={{ background: theme.colors.light }}
            >
              <InputLabel id="prefeitura-label">Prefeitura</InputLabel>
              <Select
                labelId="prefeitura-label"
                value={PREFEITURA.ID}
                label="Prefeitura"
                style={{ background: theme.colors.light }}
              >
                {prefeituras.map((item) =>
                  item.STATUS && item.STATUS.trim() == "A" ? (
                    <MenuItem
                      key={item.ID}
                      value={item.ID}
                      onClick={() => setPREFEITURA(item)}
                    >
                      {item.NOME}
                    </MenuItem>
                  ) : (
                    <></>
                  )
                )}
              </Select>
            </FormControl>
          </Grid>
        )}

        <Grid item xs={12} sm={6}>
          <FormControl
            fullWidth
            variant="outlined"
            style={{ background: theme.colors.light }}
          >
            <InputLabel id="operacao-label">Tipo de Operação</InputLabel>
            <Select
              labelId="operacao-label"
              value={OPERACAO.ID}
              onChange={(e) => {
                const selectedOperation = operacoes.find(
                  (op) => op.ID === e.target.value
                );
                if (selectedOperation) {
                  setOPERACAO(selectedOperation);
                } else {
                  setOPERACAO({} as IOperacao);
                }
              }}
              label={`Tipo de Operação: ${OPERACAO.DESCRICAO}`}
              style={{ background: theme.colors.light }}
            >
              {operacoes.map((operacao) => (
                <MenuItem key={operacao.ID} value={operacao.ID}>
                  {operacao.DESCRICAO}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {/* </Grid> */}
        {!rural && (
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              variant="outlined"
              label="Bairro"
              value={BAIRRO}
              onChange={(e) => setBAIRRO(e.target.value)}
              style={{ background: theme.colors.light }}
            />
          </Grid>
        )}

        {!rural && (
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              variant="outlined"
              label="Quadra"
              value={QUADRA}
              onChange={(e) => setQUADRA(e.target.value)}
              style={{ background: theme.colors.light }}
            />
          </Grid>
        )}

        {isRural() ? (
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              style={{ background: theme.colors.light }}
              variant="outlined"
              label="Localização"
              value={LOCALIZACAO}
              onChange={(e) => setLOCALIZACAO(e.target.value)}
            />
          </Grid>
        ) : (
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              style={{ background: theme.colors.light }}
              variant="outlined"
              label="Localização"
              value={LOCALIZACAO}
              onChange={(e) => setLOCALIZACAO(e.target.value)}
            />
          </Grid>
        )}

        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            variant="outlined"
            label="Matrícula"
            value={MATRICULA}
            onChange={(e) => {
              const valorDigitado = e.target.value;
              setMATRICULA(formatarMilhares(valorDigitado));
            }}
            style={{ background: theme.colors.light }}
            inputProps={{ inputMode: "numeric" }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            variant="outlined"
            label="Transcrição"
            value={TRANSCRICAO}
            onChange={(e) => setTRANSCRICAO(e.target.value)}
            style={{ background: theme.colors.light }}
          />
        </Grid>

        {!rural && (
          <>
            <Grid item xs={12} sm={2}>
              <TextField
                fullWidth
                variant="outlined"
                label="Lote"
                value={LOTE}
                onChange={(e) => setLOTE(e.target.value)}
                style={{ background: theme.colors.light }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextField
                fullWidth
                variant="outlined"
                label="Sublote"
                value={SUBLOTE}
                onChange={(e) => setSUBLOTE(e.target.value)}
                style={{ background: theme.colors.light }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                variant="outlined"
                label="Zona"
                value={ZONA}
                onChange={(e) => setZONA(e.target.value)}
                style={{ background: theme.colors.light }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                variant="outlined"
                label="Situação da Quadra"
                value={SITUACAO_QUADRA}
                onChange={(e) => setSITUACAO_QUADRA(e.target.value)}
                style={{ background: theme.colors.light }}
              />
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              variant="outlined"
              label="Área Total m²"
              type="text"
              value={AREA}
              onChange={(e) => setAREA(limparNumeroComVirgula(e.target.value))}
              style={{ background: theme.colors.light }}
              inputProps={{ inputMode: 'decimal' }}
            />

          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              variant="outlined"
              label="Área Transmitida m²"
              type="text"
              value={AREA_TRANSMITIDA}
              onChange={(e) => setAREA_TRANSMITIDA(limparNumeroComVirgula(e.target.value))}
              style={{ background: theme.colors.light }}
              inputProps={{ inputMode: 'decimal' }}
            />

          </Grid>
        </Grid>
      </Grid>
        {!isRural() && (
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Frente m"
                  type="text"
                  value={FRENTE}
                  onChange={(e) => setFRENTE(limparNumeroComVirgula(e.target.value))}
                  style={{ background: theme.colors.light }}
                  inputProps={{ inputMode: 'decimal' }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Fundo m"
                  type="text"
                  value={FUNDO}
                  onChange={(e) => setFUNDO(limparNumeroComVirgula(e.target.value))}
                  style={{ background: theme.colors.light }}
                  inputProps={{ inputMode: 'decimal' }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Direita m"
                  type="text"
                  value={LADO_DIREITO}
                  onChange={(e) => setLADO_DIREITO(limparNumeroComVirgula(e.target.value))}
                  style={{ background: theme.colors.light }}
                  inputProps={{ inputMode: 'decimal' }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Esquerda m"
                  type="text"
                  value={LADO_ESQUERDO}
                  onChange={(e) => setLADO_ESQUERDO(limparNumeroComVirgula(e.target.value))}
                  style={{ background: theme.colors.light }}
                  inputProps={{ inputMode: 'decimal' }}
                />
              </Grid>
            </Grid>
          </Grid>
        )}

        {/* <TextField
          fullWidth
          variant="outlined"
          label="Avaliação Terreno R$"
          type="text"
          value={VALOR_CARTORIO_TERRENO}
          onChange={(e) => {
            let valor = e.target.value;

            // Remove tudo que não for número ou vírgula
            valor = valor.replace(/[^\d,]/g, '');

            // Impede mais de uma vírgula
            const partes = valor.split(',');
            if (partes.length > 2) {
              valor = partes[0] + ',' + partes[1];
            }

            setVALOR_CARTORIO_TERRENO(valor);
          }}
          style={{ background: theme.colors.light }}
          inputProps={{ inputMode: 'decimal' }}
        /> */}



        {isRural() && tipo_terras.length > 0 && (
          <>
            {Object.entries(
              tipo_terras.reduce((acc, tipo, index) => {
                if (!acc[tipo.grupo]) acc[tipo.grupo] = [];
                acc[tipo.grupo].push({ ...tipo, index });
                return acc;
              }, {} as Record<string, { descricao: string; grupo: string; index: number }[]>)
            ).map(([grupo, itens]) => (
              <div key={grupo}>
                <Typography variant="h6" gutterBottom>
                  {grupo}
                </Typography>
                <Grid container spacing={2}>
                  {itens.map(({ descricao, index }) => (
                    <Grid item xs={12} sm={3} key={index}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label={`${descricao} %`}
                        type="text"
                        value={TIPO_TERRA_CAMPOS[index]}
                        onChange={(e) => {
                          const valorLimpo = limparNumeroComVirgula(e.target.value);
                          const newTIPO_TERRA_CAMPOS = [...TIPO_TERRA_CAMPOS];
                          newTIPO_TERRA_CAMPOS[index] = valorLimpo;
                          setTIPO_TERRA_CAMPOS(newTIPO_TERRA_CAMPOS);
                        }}
                        style={{ background: theme.colors.light }}
                        inputProps={{ inputMode: 'decimal' }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </div>
            ))}
          </>
        )}


      </Grid>

      {/* Botões */}
      <Grid container spacing={2} style={{ marginTop: 8 }} justify="center">
        <Grid item>
          <Button variant="contained" color="primary" onClick={handleClose}>
            CANCELAR
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" onClick={post}>
            CONFIRMAR
          </Button>
        </Grid>
      </Grid>

      {/* Mensagem de erro */}
      <Alert
        title={error.title}
        message={error.message}
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
      />
      <ModalLoader loading={loading} />
    </Container>
  );
}
